import { useMemo } from "react";

import { WithConfiguration } from "Components/Generic/Configuration";
import { KeyValueGrid } from "Components/Generic/KeyValueGrid";
import { IKeyValue } from "Components/Generic/KeyValueGrid/IKeyValue";
import { Value } from "Components/Generic/KeyValueGrid/Value";
import { WithTranslator } from "Components/Generic/Translator";
import { EntityType } from "Model/EntityType";
import { hasNoElements } from "Utils/Array";
import { getTranslatedFieldLabel } from "Utils/Field";
import { IContactInfoProps } from "./IContactInfoProps";
import { useContactInfoStyles } from "./UseContactInfoStyles";

export const ContactInfo = WithConfiguration(
  WithTranslator((props: IContactInfoProps): JSX.Element => {
    const { config, contact, translator } = props;
    const contactTiles = config.getContactTileFields();
    const { gridStyles } = useContactInfoStyles();

    const items = useMemo((): IKeyValue[] => {
      if (hasNoElements(contactTiles)) {
        return null;
      }

      return contactTiles.map((fieldMeta) => {
        const { fieldName } = fieldMeta;
        return {
          key: getTranslatedFieldLabel(fieldName, EntityType.Contact, translator),
          value: <Value {...fieldMeta} item={contact} placeholder="-" />,
          isEmpty: contact?.[fieldName] == null,
          isRequired: false
        };
      });
    }, [contact, contactTiles, translator]);

    if (items == null) {
      return null;
    }

    return <KeyValueGrid items={items} styleSet={gridStyles} />;
  })
);
